var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertaLimiteVelocidade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1257 0.951355H19.4431L0.484375 19.9101V46.5927L19.4431 65.5514H46.1257L65.0844 46.5927V19.9101L46.1257 0.951355Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.904 31.0278H60.5214C59.9362 25.4104 57.7127 20.2611 54.3188 16.1651L50.3398 20.1441C52.7975 23.3039 54.4359 26.9318 54.904 31.0278Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4774 16.2822L50.4564 12.3032C46.3604 8.90934 41.2111 6.68579 35.5938 6.10065V11.718C39.5727 12.1862 43.3177 13.8246 46.4774 16.2822Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.976 11.718V6.10065C24.3586 6.68579 19.2093 8.90934 15.1133 12.3032L19.0923 16.2822C22.135 13.8246 25.8799 12.1862 29.976 11.718Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1322 16.1651C7.73838 20.3781 5.51483 25.5274 4.92969 31.0278H10.5471C11.0152 26.9318 12.6536 23.1868 15.1112 20.1441L11.1322 16.1651Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6416 20.6878L35.7695 43.7059H29.8716L28.9995 20.6878H36.6416ZM28.793 50.8431C28.793 49.818 29.1602 48.9536 29.8945 48.2498C30.6289 47.546 31.6004 47.1942 32.8091 47.1942C34.0024 47.1942 34.9587 47.546 35.6777 48.2498C36.4121 48.9536 36.7793 49.818 36.7793 50.8431C36.7793 51.8834 36.4121 52.7555 35.6777 53.4593C34.9587 54.1478 34.0024 54.492 32.8091 54.492C31.6004 54.492 30.6289 54.1478 29.8945 53.4593C29.1602 52.7555 28.793 51.8834 28.793 50.8431Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaLimiteVelocidade);
export default __webpack_public_path__ + "static/media/alerta-limite-velocidade.88de27475678bcece3a27f89d5a38cb1.svg";
export { ForwardRef as ReactComponent };